/* @flow */

export const durationOptions = [
    {value: 2, label: '2 minutes'},
    {value: 5, label: '5 minutes'},
    {value: 10, label: '10 minutes'},
    {value: 15, label: '15 minutes'},
    {value: 30, label: '30 minutes'},
    {value: 45, label: '45 minutes'},
    {value: 60, label: '1 hour'},
    {value: 90, label: '1.5 hours'},
    {value: 120, label: '2 hours'},
];

export const defaultDurationOption = {value: 15, label: '15 minutes'};
